/**
 * The API returns naive timestamps (no zone) that are in UTC. Appending `Z`
 * makes `new Date` / `parseISO` read them as UTC — but only when the value has
 * no zone yet. A value that already ends in `Z` or `±HH:MM` must be left alone:
 * `...+03:00Z` is not valid ISO 8601 and parses wrong or not at all.
 */
const TIMEZONE_SUFFIX = /(Z|[+-]\d{2}:?\d{2})$/i;

export function toUTCDateString(dateString: string): string {
  return TIMEZONE_SUFFIX.test(dateString) ? dateString : `${dateString}Z`;
}
